import type {
  TranslateCostOptions,
  TranslateCostValue,
} from "./translate-cost.type";

const getCostFormatOptions = (
  currency: Intl.NumberFormatOptions["currency"]
): Intl.NumberFormatOptions => ({
  style: currency ? "currency" : undefined, // avoid JS error when referential currencies is loading
  currency,
  currencyDisplay: "narrowSymbol",
  trailingZeroDisplay: "stripIfInteger",
});

export const translateCost = (
  value: TranslateCostValue,
  options: TranslateCostOptions
) => {
  if (typeof value !== "number") return "";

  const { locale, currency, ...customOptions } = options ?? {};
  const formatOptions = { ...getCostFormatOptions(currency), ...customOptions };

  return new Intl.NumberFormat(locale, formatOptions).format(value);
};

export const getCostSymbol = (
  locale: Intl.LocalesArgument,
  currency: Intl.NumberFormatOptions["currency"]
) => {
  const formatOptions = getCostFormatOptions(currency);

  const parts = new Intl.NumberFormat(locale, formatOptions).formatToParts(1);

  return parts?.find((part) => part.type === "currency")?.value;
};
